// Barn
export const GET_ME_STREAM_REQUESTED = 'GET_ME_STREAM_REQUESTED';
export const GET_ME_STREAM_SUCCESS = 'GET_ME_STREAM_SUCCESS';
export const GET_ME_STREAM_ERROR = 'GET_ME_STREAM_ERROR';
